module.exports = __webpack_public_path__ + "static/img/3.9a98154.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/3.png
// module id = Whbn
// module chunks = 0